import HistoryService from 'src/lib/api/history.service';

export async function searchProductTrails({ commit }, { params }) {
  const response = await HistoryService.searchProductTrails({ params });
  if (response.status === 200) {
    commit('updateProductTrails', { productTrails: response.data.data });
    commit('updateMeta', {
      meta: {
        next: response.data.next,
        previous: response.data.previous,
        rowCount: response.data.total,
      },
    });
  }
}
